import * as React from 'react';

function SvgControlRadioOff(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 15a9 9 0 1018 0 9 9 0 00-18 0zm16.916 0a7.916 7.916 0 11-15.832 0 7.916 7.916 0 0115.832 0z"
        fill="#D3D6D9"
      />
    </svg>
  );
}

export default SvgControlRadioOff;
